__turbopack_context__.v({
  "wrapper": "_2jYDVa_wrapper",
});
